import React, { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext(undefined);

function useCartContext() {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error("useCartContext must be used within a CartProvider");
  }
  return context;
}

const CartProvider = (props) => {
  const initialStateDiscount = {
    code: null,
    percentage: null,
    type: null,
    save: null,
    min_value: null,
  };

  const [applyDiscount, setApplyDiscount] = useState(() => {
    const savedDiscount = localStorage.getItem("cartData");
    return savedDiscount ? JSON.parse(savedDiscount) : initialStateDiscount;
  });

  // Save discount to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("cartData", JSON.stringify(applyDiscount));
  }, [applyDiscount]);

  let cartObj = {
    applyDiscount,
    setApplyDiscount,
  };

  return <CartContext.Provider {...props} value={cartObj} />;
};

export { CartProvider, useCartContext };
